<cl-dialog #dialog [heading]="header()" [alert]="true" [ariaDescribedby]="messageId" (closed)="cancelled.emit()">
    <p class="message" [id]="messageId">{{ message() }}</p>
    <app-button clDialogFooter variant="text" severity="secondary" (click)="dialog.close()">{{ cancelLabel() }}</app-button>
    <app-button clDialogFooter severity="danger" (click)="confirm.emit()">{{ confirmLabel() }}</app-button>
</cl-dialog>
